import React, { useMemo } from 'react';
import { merge } from 'lodash';
import useSettings from '@hooks/useSettings';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { useThemeMode } from '@contexts/ThemeMode/ThemeModeContext';
import themeOptions from './themeOptions';

// Dark palette for MUI; light mode keeps the configured settings theme.
const darkPalette = {
  palette: {
    mode: 'dark',
    type: 'dark',
    primary: { main: '#0ea5e9', contrastText: '#ffffff' },
    secondary: { main: '#22d3ee', contrastText: '#0b1120' },
    error: { main: '#f43f5e' },
    background: { paper: '#111a2e', default: '#0b1120' },
    text: {
      primary: '#e2e8f0',
      secondary: '#94a3b8',
      disabled: '#64748b',
      hint: '#64748b'
    },
    divider: '#1c2742'
  }
};

const darkTheme = createTheme(merge({}, themeOptions, darkPalette));

const Theme = ({ children }) => {
  const { settings } = useSettings();
  const { mode } = useThemeMode();
  const activeTheme = useMemo(
    () => (mode === 'dark' ? darkTheme : { ...settings.themes[settings.activeTheme] }),
    [mode, settings.themes, settings.activeTheme]
  );

  return (
    <ThemeProvider theme={activeTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default Theme;
